import { Link } from "react-router-dom";
import { Table, Icon } from "semantic-ui-react";
import { ISubtask } from "../../models/subtask";
import { formatPriority } from "../CalculationProperties/Props/CalcPropsGeneralInfo";

type Props = {
    subtask: ISubtask;
    reports: boolean;
    priority: number;
};

export const SubtaskRow = ({ subtask, reports, priority }: Props) => {
    let result =
        subtask.result === "Process finished with status: 0"
            ? "Success"
            : subtask.result === "Process finished with status: 2"
            ? "Fallback"
            : "Failed";

    if (subtask.result === "Manually stopped") {
        result = "Manually stopped";
    }

    return (
        <Table.Row id={`tableRow-subtaskRow-${subtask.id}`} key={subtask.id}>
            <Table.Cell id={`tableCell-subtaskRow-a-${subtask.id}`} singleLine>{subtask.name}</Table.Cell>
            <Table.Cell id={`tableCell-subtaskRow-b-${subtask.id}`} singleLine>
                {subtask.isComplete ? <Icon name="check" /> : <Icon name="close" />}
            </Table.Cell>
            <Table.Cell id={`tableCell-subtaskRow-c-${subtask.id}`} singleLine>
                {subtask.isRunning ? <Icon name="check" /> : <Icon name="close" />}
            </Table.Cell>
            <Table.Cell id={`tableCell-subtaskRow-d-${subtask.id}`} singleLine>{formatPriority(priority)}</Table.Cell>
            <Table.Cell id={`tableCell-subtaskRow-e-${subtask.id}`} singleLine>{formatSubtaskDateString(subtask.started)}</Table.Cell>
            <Table.Cell id={`tableCell-subtaskRow-f-${subtask.id}`} singleLine>{formatSubtaskDateString(subtask.finished)}</Table.Cell>
            <Table.Cell id={`tableCell-subtaskRow-g-${subtask.id}`} className="subtask-result">{result}</Table.Cell>
            <Table.Cell id={`tableCell-subtaskRow-h-${subtask.id}`} singleLine textAlign="right">
                <Link id={`link-tasks-action-subtaskRow-${subtask.id}`} className="tasks-action" to={`/Calculations/Subtask/${subtask.id}`}>
                    Console
                </Link>
                {subtask.isComplete && reports && (
                    <span id={`span-subtaskRow-a-${subtask.id}`}>&nbsp;</span>
                )}
            </Table.Cell>
        </Table.Row>
    );
};

const formatSubtaskDateString = (date: string) => {
    if (date === "0001-01-01T00:00:00") return "N/A";
    else return date.replace("T", " ").substring(0, date.indexOf("."));
};
